<template>
  <a-modal
    title="发送测试邮件"
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :width="576"
    wrap-class-name="test-email-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p class="prompt">
      每日可免费发送5封测试邮件，今日剩余发送：{{ usedNum }}
    </p>
    <a-form
      ref="form"
      :form="form"
    >
      <a-form-item label="发件人：">
        <a-input
          value="星轨询盘管理"
          :disabled="true"
        />
      </a-form-item>
      <a-form-item label="发件邮箱：">
        <a-input
          value="westartrack@westartrack.com"
          :disabled="true"
        />
      </a-form-item>
      <a-form-item label="收件人：">
        <a-input
          v-decorator="['email', {
            rules: [{
              required: true, message: '请输入'
            }, { validator: checkEmail }],
            initialValue: email
          }]"
          placeholder="请输入收件人"
          @change="handleInput($event, 'email',)"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getStorage } from '@/lib/storage'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    emailName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      email: '',
      usedNum: 0
    }
  },

  computed: {
    ...mapState('edm', ['emailNum'])
  },

  watch: {
    visible (val) {
      this.getEmailNum()
    }
  },

  mounted () {
    this.getEmailNum()
  },

  methods: {
    ...mapActions('edm', ['fetchEmailNum']),
    ...mapActions('edm/editEmail', ['testSend']),
    handleInput (e, name) {
      let val = e.target.value
      this[name] = val
    },
    hide () {
      this.email = ''
      this.form.resetFields()
      this.$emit('update:visible', false)
    },
    async getEmailNum () {
      let chain = await this.fetchEmailNum()
      chain.onSuccess(res => {
        this.usedNum = this.emailNum.testNum
      })
    },
    checkEmail (rule, value, callback) {
      if (value && !/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,64}$/.test(value)) {
        rule.message = '邮箱不是有效的邮箱格式'
        callback(rule.message)
      }
      callback()
    },
    handleOk () {
      let _this = this
      let emailContent = getStorage('email.content')
      if (emailContent === '') {
        this.$message.destroy()
        this.$message.error('邮件内容不能为空')
        return
      }
      if (this.emailName === '') {
        this.$message.destroy()
        this.$message.error('邮件主题不能为空')
        return
      }
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let chain = await this.testSend({
            email: this.email,
            name: this.emailName,
            content: emailContent
          })
          chain
            .config({
              error100 (raw = {}) {
                let num = 5
                let { payload = {} } = raw
                _this.usedNum = payload.testNum

                if (_this.usedNum === 0) {
                  _this.hide()
                  _this.testComfirm(num)
                }
              },
              error102 (raw = {}) {
                let { message = '' } = raw
                _this.$message && _this.$message.destroy()
                _this.$message.error(message)
              }
            })
            .onSuccess(res => {
              this.hide()
            })
        }
      })
    },
    testComfirm (num) {
      this.$confirm({
        title: '测试邮件发送机会已用完',
        content: <div>每日有{num}封测试邮件发送机会，今日测试邮件发送机会<span class='fs-orange'>已用完</span></div>,
        closable: true,
        okText: '知道了',
        okType: 'primary',
        cancelText: '',
        class: 'confirm-warn-modal test-email-used-modal',
        onOk: async () => {}
      })
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>
<style scoped lang="scss">
.prompt {
  height:40px;
  line-height: 40px;
  margin-bottom: 24px;
  padding: 0 24px;
  background:#E8F4FF;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 120px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 120px;
}
</style>
<style lang="scss">
.test-email-modal {
  .ant-modal-body {
    padding: 0;
  }
}
.test-email-used-modal {
  .ant-btn-default {
    display: none;
  }
}
</style>
